// extracted by mini-css-extract-plugin
export default {"custom_input":"date-input_custom_input__X6PxO"};